import React, { useState } from 'react';
import './OurObjectives.css';
import { FaLanguage } from 'react-icons/fa';

const OurObjectives = () => {
  const englishPoints = [
"Helping economically backward and poor couples in society to get married.To create awareness about the prevention of dowry, child marriage, and gender discrimination, promoting equality and dignity in marital relationships.",
"To create awareness to curb child marriage, gender discrimination and promote equality and dignity in marital relationships.",
"To work in partnership with government and non-governmental organizations to provide marriage and counseling assistance to those in need in other regions.",
"To publish information on marriage and astrology related relationship health on websites, social media, magazines, pamphlets, newspapers, etc.",

"To provide educational assistance. Books, bags, pens, pencils, uniforms for poor children.",
"To raise funds, accept donations and receive grants from individuals, institutions and organizations to support the charitable and social objectives of the Trust.",

"To arrange for the provision of medical equipment such as hospitalization, surgery, eye surgery, eye examinations and guiding glasses to meet the medical needs of the poor.",

"To undertake, initiate or assist in social development activities or welfare programs to bring about a positive change in the lives of the common people.",
"To provide food and clothing to the poor and needy such as widows, the elderly and street dwellers.",

"To provide essential assistance such as shelter to destitute children and the elderly.",
"To engage in activities such as cleaning of garbage bins and rural areas to carry out the Swachh Bharat Mission",

    
  ];

  const tamilPoints = [
    "சமூதாயத்தில் பொருளாதாரத்தில் பின்தங்கிய, ஏழ்மை நிலையில் உள்ள ஆண்/பெண் இருவருக்கும் திருமணம் செய்ய உதவி செய்தல்",
    "குழந்தை திருமணம், பாலினப் பாகுபாடு ஆகியவற்றைக் கட்டுப்படுத்தும் விழிப்புணர்வை ஏற்படுத்துதல் மற்றும் திருமண உறவுகளில் சமத்துவம் மற்றும் கண்ணியத்தை மேம்படுத்துதல்.",
    "வேறு பிராந்தியங்களில் தேவைப்படுபவர்களுக்கு திருமண மற்றும் ஆலோசனை உதவிகளை வழங்க அரசு மற்றும் அரசு சாரா அமைப்புகளுடன் இணைபிரியா செயற்பாடுகள்.",
    "திருமணம் மற்றும் ஜோதிடம் சம்மந்தமான  உறவுத் நலத்திற்கான செய்திகளை இணையதளம், சமூகவளைத்தளங்கள்  பத்திரிகைகள், சிறு நூல்கள், செய்தித்தாள்கள் போன்றவற்றில் வெளியிடுதல்.",
    "ஏழை பிள்ளைகளுக்காக கல்வி உதவிகள்.புத்தகங்கள், பைகள், பேனாக்கள், பென்சில்கள், யூனிபார்ம்கள் வழங்குதல்.",
    "ஏழை மக்கள் மருத்துவ தேவைகளை பூர்த்தி செய்ய மருத்துவமனையில் அனுமதி, அறுவை சிகிச்சை, கண் அறுவை சிகிச்சை, கண் ஆய்வுகள் மற்றும் வழிகாட்டும் கண்ணாடிகள் போன்ற மருத்துவ உபகரங்கள் வழங்க ஏற்ப்பாடு செய்தல்.",
    "விதவைகள், முதியவர்கள் மற்றும் தெருவில் வசிப்பவர்கள் போன்ற ஏழை மற்றும் தேவையுடையவர்களுக்கு உணவு மற்றும் ஆடைகள் வழங்குதல்.",
    "சாமானிய மக்களின் வாழ்க்கையில் நேர்மறையான மாற்றத்தைக் கொண்டுவருவதற்கான சமூக மேம்பாட்டு நடவடிக்கைகள் அல்லது நலத்திட்டங்களை மேற்கொள்ளுதல், தொடங்குதல் அல்லது உதவுதல்.",
    "அறக்கட்டளையின் தொண்டு மற்றும் சமூக நோக்கங்களை ஆதரிப்பதற்காக நிதி திரட்டுதல், நன்கொடைகளை ஏற்றுக்கொள்வது மற்றும் தனிநபர்கள், நிறுவனங்கள் மற்றும் நிறுவனங்களிடமிருந்து மானியங்களைப் பெறுதல்.",
    "ஆதரவற்ற குழந்தைகள் மற்றும் முதியவர்களுக்கு இருப்பிடம் போன்ற அத்திவாசிய உதவிகள் செய்தல்.",
    "தூய்மை இந்தியா திட்டத்தை நடத்துவதற்காக குப்பைத் தொட்டி மற்றும் கிராமப் பகுதிகளை சுத்தம் செய்தல் ஆகிய செயல்களில் ஈடுபடுதல்"
  ];

  const [isTamil, setIsTamil] = useState(false);
  const [showAll, setShowAll] = useState(false);

  const togglePoints = () => setShowAll(!showAll);
  const toggleLanguage = () => setIsTamil(!isTamil);

  const visiblePoints = showAll
    ? (isTamil ? tamilPoints : englishPoints)
    : (isTamil ? tamilPoints.slice(0, 6) : englishPoints.slice(0, 6));

  return (
    <div className="objectives-section">
      <div className="top-section">
        {/* Translate Button at Top Left */}
        <div className="top-controls">
          <button
            className="translate-btn"
            onClick={toggleLanguage}
          >
            <FaLanguage />
            {isTamil ? 'Translate to English' : 'Translate to தமிழ்'}
          </button>
        </div>

        {/* Title */}
        <h2>{isTamil ? 'எங்கள் நோக்கங்கள்' : 'OUR OBJECTS'}</h2>

        {/* Image */}
        <div className="objectives-image">
          <img src="/object.png" alt="Objectives" />
        </div>
      </div>

      {/* Objectives Text */}
      <div className="objectives-text">
        <ol>
          {visiblePoints.map((point, index) => (
            <li key={index}>{point}</li>
          ))}
        </ol>

        <div style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
          <button className="toggle-btn" onClick={togglePoints}>
            {showAll ? (isTamil ? 'குறைவாக வாசிக்க' : 'Read Less') : (isTamil ? 'மேலும் வாசிக்க' : 'Read More')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OurObjectives;
